import React from "react"

import { Trans, useTranslation } from "@bounce/i18n"

import { FAQs as BaseFAQs } from "../../../../components/Generic/FAQs/FAQs"
import { useFAQs } from "../../../../components/LuggageStorage/FAQs/useFAQs"

export const FAQs = () => {
  const { t } = useTranslation("marketing-ls-app")

  const genericFaqs = useFAQs()
  const appDownloadFaq = {
    id: "Why should I use a luggage storage app?",
    question: t("cmp.customerFaq.whyLuggageStorageApp.question", "Why should I use a luggage storage app?"),
    answer: (
      <Trans ns="marketing-ls-app" i18nKey="cmp.customerFaq.whyLuggageStorageApp.answer">
        To find the most convenient location to drop off your stuff, using the Bounce luggage storage app is the best
        way to do it. Bounce can show you the most accurate results for storage spots near you if you download the app
        and share your location. Once you’ve booked, you can navigate directly to the store via maps or ride-share
        services. <br />
        <br />
        Managing your bookings is even easier on the Bounce luggage storage app. Easily access your current, upcoming,
        and past bookings and change your drop-off and pick-up times if your schedule changes. If you have any questions
        or concerns about your booking, you can message your store partner or contact support 24/7.
        <br />
        <br />
        If you’re traveling abroad or don’t have good cell service, you can save your booking details for offline access
        on the Bounce luggage storage app. This is a great option if you don’t want to use extra data on your trip or
        might not be able to find good WiFi. You can also check the store hours and view your booking info without
        needing an internet connection.
      </Trans>
    ),
    structuredAnswer: t(
      "cmp.customerFaq.whyLuggageStorageApp.structuredAnswer",
      "To find the most convenient location to drop off your stuff, using the Bounce luggage storage app is the best way to do it. Bounce can show you the most accurate results for storage spots near you if you download the app and share your location. Once you’ve booked, you can navigate directly to the store via maps or ride-share services. Managing your bookings is even easier on the Bounce luggage storage app. Easily access your current, upcoming, and past bookings and change your drop-off and pick-up times if your schedule changes. If you have any questions or concerns about your booking, you can message your store partner or contact support 24/7. If you’re traveling abroad or don’t have good cell service, you can save your booking details for offline access on the Bounce luggage storage app. This is a great option if you don’t want to use extra data on your trip or might not be able to find good WiFi. You can also check the store hours and view your booking info without needing an internet connection.",
    ),
  }

  const faqs = [appDownloadFaq, ...genericFaqs]

  return <BaseFAQs faqs={faqs} className="py-section" />
}
